module.exports = __webpack_public_path__ + "static/img/freight.3cb48f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/freight.png
// module id = 2RDx
// module chunks = 1